var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOnboarding = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20.5018C2.067 20.5018 0.5 18.9348 0.5 17.0018C0.5 15.0688 2.067 13.5018 4 13.5018C5.585 13.5018 6.924 14.5558 7.355 16.0018H13V14.0018H15V8.24381L12.757 6.00181H7V8.00181H1V2.00181H7V4.00181H12.757L16 0.757812L20.243 5.00181L17 8.24281V14.0018H19V20.0018H13V18.0018H7.355C6.925 19.4478 5.585 20.5018 4 20.5018ZM4 15.5018C3.172 15.5018 2.5 16.1738 2.5 17.0018C2.5 17.8298 3.172 18.5018 4 18.5018C4.828 18.5018 5.5 17.8298 5.5 17.0018C5.5 16.1738 4.828 15.5018 4 15.5018ZM17 16.0018H15V18.0018H17V16.0018ZM16 3.58781L14.586 5.00181L16 6.41581L17.414 5.00181L16 3.58781ZM5 4.00181H3V6.00181H5V4.00181Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnboarding);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/onboarding.svg";